import request from "./request";
export const loginApi = (data) => {
  return request({
    url: `/v1/uim/common/app/login`,
    data,
    isToken: false,
    method: "post",
    headers: { "content-type": "application/json" },
  });
};

export const logoutApi = (token) => {
  return request({
    url: "/v1/uim/user/cancel/account",
    method: 'post',
    headers: {'token': token}
  });
};
